import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=0a6630f7&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"
import style0 from "./MainSection.vue?vue&type=style&index=0&id=0a6630f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6630f7",
  null
  
)

export default component.exports